import { Outlet } from 'react-router-dom';
import { Footer } from '../Footer';
import NavbarEvents from '../Navbar/NavbarEvents';

const LayoutUnknownRoutes = () => {
  return (
    <>
      <NavbarEvents />
      <Outlet />
      <Footer style={{ bottom: 0, left: 0, width: '100%' }} />
    </>
  );
};
export default LayoutUnknownRoutes;
